import { useLang } from '@/i18n';
import XCore from '@elem/SVGIcon/FourInOne/XCore';
import EfSectionMiddle from '@elem/ui/ef-section-middle';
import styles from './index.module.scss';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('fourinone.teaser');
    const { locale } = useRouter();

    const itemA = {
        title: t('x_core_title'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724148558284/x_core_bg.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724208613572/x_core_bg_h5.jpg',
        moreLink: `https://www.ecoflow.com/${locale}/x-core-3`,
        btnText: t('x_core_btn'),
    };
    return (
        <div className={styles.TheComp}>
            <EfSectionMiddle
                hasAnimation={false}
                label={
                    <div className="section-center-icon">
                        <XCore color="white" />
                    </div>
                }
                title={itemA.title}
                theme="white"
                pc={itemA.pc}
                h5={itemA.h5}
                moreLink={itemA.moreLink}
                moreText={itemA.btnText}
            />
        </div>
    );
}
